<template>
  <d-container fluid class="px-4 main-content-container">
    <!-- Page Header -->
    <d-row no-gutters class="py-4 page-header">
      <div class="mb-0 text-center col-12 text-sm-left">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Revistas</h3>
        <router-link class="float-right text-white btn btn-success " :to="{ name: 'admin-magazine-new' }">Nova revista</router-link>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="mb-4 card-small">
          <div class="card-header border-bottom d-flex justify-content-around">
            <d-col cols="12" md="4">
              <h6 class="m-0">Revistas Ativos</h6>
            </d-col>
            <d-col cols="12" md="8">
              <form class="main-sidebar__search">
                <d-row>
                  <d-col cols="3">
                    <d-select v-model="pagination.status_id">
                      <option :value="null">Filtro por status</option>
                      <option :value="status.id" v-for="status in statuses" :key="status.id">{{ status.name }}</option>
                    </d-select>
                  </d-col>
                  <d-col cols="3">
                    <d-select v-model="pagination.type_id">
                      <option :value="null">Filtro por tipo</option>
                      <option :value="type.id" v-for="type in types" :key="type.id">{{ type.name }}</option>
                    </d-select>
                  </d-col>
                  <d-col cols="6">
                    <div class="ml-3 input-group input-group-seamless">
                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <i class="fas fa-search"></i>
                        </div>
                      </div>
                      <input
                        class="navbar-search form-control"
                        type="text"
                        placeholder="Procurar por algo..."
                        aria-label="Search"
                        v-model="pagination.search"
                      >
                    </div>
                  </d-col>
                </d-row>
              </form>
            </d-col>
          </div>
          <div class="p-0 pb-3 text-left card-body">
            <div class="table-overflow">
              <magazine-table :magazines="magazines.list" />
            </div>
            <pagination :total-items="magazines.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import MagazineTable from '../components/MagazineListTable.vue';

export default {
  name: 'magazine-list',
  components: {
    Pagination,
    MagazineTable,
  },
  data() {
    return {
      pagination: {
        search: '',
        type_id: null,
        status_id: null,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    types() {
      const { types } = this.$store.state.puzzle;
      if (types.length) {
        return types;
      }
      return [];
    },
    statuses() {
      const { status } = this.$store.state.puzzle;
      if (status.length) {
        return status;
      }
      return [];
    },
    magazines() {
      const { magazineList } = this.$store.state.magazine;
      if (magazineList && magazineList.list.length) {
        return magazineList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getTypesList',
      'getStatusList',
      'getMagazineList',
    ]),
    getList() {
      this.getMagazineList(this.pagination);
    },
    getOptions() {
      if (this.types.length === 0) {
        this.getTypesList();
      }
      if (this.statuses.length === 0) {
        this.getStatusList();
      }
    },
  },
  mounted() {
    this.getOptions();
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
</style>
